import {
  Card,
  DataDisplay,
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@compass/core";
import { Select } from "components";
import {
  SurveyReportAnswer,
  SurveyReportQuestion,
  SurveyReportRequest,
  SurveyReportResponse,
  SurveyReportViewResource,
} from "generated/openApi";
import produce from "immer";

import { useDispatch } from "react-redux";

export const SurveyReportReportResultFilter = (props: {
  viewResource: SurveyReportViewResource;
  surveyReportResult: SurveyReportResponse;
  surveyReportRequest: SurveyReportRequest | undefined;
  setSurveyReportRequest: (value: SurveyReportRequest) => void;
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();


  const regionField = () => {
    return (
      <Grid item xs={4}>
        <Select
          label="Regions"
          multiple
          value={props.surveyReportResult.selectLists?.regionSelectList?.filter((x) => props.surveyReportRequest?.regionIds?.map((r) => r).includes(x.id))}
          options={props.surveyReportResult.selectLists?.regionSelectList}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) => {
            props.setSurveyReportRequest(
              produce(props.surveyReportRequest!, (draft) => {
                draft.regionIds = values.map((x) => x.id);
              })
            );
          }}
        />
      </Grid>
    );
  };

  const districtField = () => {
    return (
      <Grid item xs={4}>
        <Select
          label="Districts"
          multiple
          value={props.surveyReportResult.selectLists?.districtSelectList?.filter((x) => props.surveyReportRequest?.districtIds?.map((r) => r).includes(x.id))}
          options={props.surveyReportResult.selectLists?.districtSelectList}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) => {
            props.setSurveyReportRequest(
              produce(props.surveyReportRequest!, (draft) => {
                draft.districtIds = values.map((x) => x.id);
              })
            );
          }}
        />
      </Grid>
    );
  };

  const schoolField = () => {
    return (
      <Grid item xs={4}>
        <Select
          label="Schools"
          multiple
          value={props.surveyReportResult.selectLists?.schoolSelectList?.filter((x) => props.surveyReportRequest?.schoolIds?.map((r) => r).includes(x.id))}
          options={props.surveyReportResult.selectLists?.schoolSelectList}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) => {
            props.setSurveyReportRequest(
              produce(props.surveyReportRequest!, (draft) => {
                draft.schoolIds = values.map((x) => x.id);
              })
            );
          }}
        />
      </Grid>
    );
  };

  const gradeLevelField = () => {
    return (
      <Grid item xs={4}>
        <Select
          label="Grade Levels"
          multiple
          value={props.surveyReportResult.selectLists?.gradeLevelSelectList?.filter((x) => props.surveyReportRequest?.gradeLevelIds?.map((r) => r).includes(x.id))}
          options={props.surveyReportResult.selectLists?.gradeLevelSelectList}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) => {
            props.setSurveyReportRequest(
              produce(props.surveyReportRequest!, (draft) => {
                draft.gradeLevelIds = values.map((x) => x.id);
              })
            );
          }}
        />
      </Grid>
    );
  };



  return (
    <Card header={"Parameters"}>
      <Grid container spacing="sm" alignItems="center">
        {props.viewResource.canAccessRegionFilter && (regionField())}
        {props.viewResource.canAccessDistrictFilter && (districtField())}
        {props.viewResource.canAccessSchoolFilter && (schoolField())}
        {gradeLevelField()}
      </Grid>
    </Card>
  );
};
